import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Profile } from './profile';
import {TranslateService} from '@ngx-translate/core';
import { MatRadioChange } from '@angular/material/radio';
import { APP_Constants } from '../app.constant';
import { AppService } from '../app.service';
import { Modal } from 'src/app/common/modal/modal';
import { ModalService } from '../common/modal/modal.service';
import { CustomSnackBarService } from 'src/app/common/snack-bar/snack-bar.service';
@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProfileComponent implements OnInit {
  userName;
  firstName;
  lastName;
  contactNumber;
  userRole;
  secondaryUserRoles;
  customerName;
  profileData;
  preferredUOM;
  selectedpreferredUOM;
  defaultUOM;customerCode;
  durationInSeconds = 20;
  userAcessDataRest:any;
  parameterValue;
  configData = {
    header:'PROFILE.HEADER'
  }
  constructor(private translate: TranslateService, private appService: AppService,private modalService: ModalService,private _snackBar: CustomSnackBarService) {
   
  }

  ngOnInit() {
    this.userName = localStorage.getItem('userName');
    this.firstName = localStorage.getItem('firstName');
    this.lastName = localStorage.getItem('lastName');
    this.contactNumber = JSON.parse(localStorage.getItem("userData"))?.contactNumber ?? '';
    this.userRole = localStorage.getItem('userRole');
    this.preferredUOM = localStorage.getItem('preferredUOM');
    this.customerCode = localStorage.getItem('customerCode');
    this.secondaryUserRoles = localStorage.getItem('secondaryUserRoles');
    this.customerName = localStorage.getItem('customerName');
    this.selectedpreferredUOM = localStorage.getItem('selectedpreferredUOM');
    this.userAcessDataRest = JSON.parse(localStorage.getItem('userAcessDataRest'))
    this.parameterValue = JSON.parse(localStorage.getItem('parameterValue'))
    if (this.selectedpreferredUOM == this.preferredUOM) {
      this.defaultUOM = this.preferredUOM;
    }
    else if (this.preferredUOM !== null) {
      this.defaultUOM = this.preferredUOM;
    }
    this.profileData = [
      { label: 'User Name', value: this.userName },
      { label: 'First Name', value: this.firstName },
      { label: 'Last Name', value: this.lastName },
      { label: 'Contact Number', value: this.contactNumber },
      { label: 'Customer Name', value: this.customerName },
      { label: 'User Role', value: this.userRole },
      { label: 'Secondary User Roles', value: this.secondaryUserRoles },
      { label: 'Department ID', value:this.userAcessDataRest !== null ? this.userAcessDataRest.departmentId : null},  
      { label: 'Vendor ID', value:this.userAcessDataRest !== null ? this.userAcessDataRest.vendorId : this.parameterValue  }
     
    ];
    if (!!this.preferredUOM){
      this.profileData.push({
        label: 'Units of Measurements (UoM)',
        value:this.defaultUOM,
        radioOptions: ['imperial','metric'],
      });
    }
  }
  onRadioChnage(event: Event): void {
    const target = event.target as HTMLInputElement;
    let SelectedData = {
      "preferredUOM": target.value
    }
    this.appService.makeHttpPutRequest(APP_Constants.UOM_SAVE_API + localStorage.getItem('userName') + '&customerCode=' + localStorage.getItem('customerCode'), SelectedData).subscribe(data => {
      if (data['message'].statusCode == APP_Constants.SUCCESS_CODE) {
        localStorage.setItem('preferredUOM', target.value);
        this._snackBar.open({ value: target.value, message: data['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
      }
    }
    );
  }
  displayedColumns: string[] = ['label', 'value'];
}